// extracted by mini-css-extract-plugin
export var actionButton = "_ou-0";
export var actionMenuContainer = "_ou-i";
export var bubble = "_ou-2";
export var bubbleActionMenu = "_ou-j";
export var bubbleContext = "_ou-6";
export var bubbleItems = "_ou-7";
export var customer = "_ou-3";
export var divider = "_ou-8";
export var fileList = "_ou-9";
export var hiddenComment = "_ou-o";
export var infoAbove = "_ou-a";
export var internal = "_ou-4";
export var lightActionButton = "_ou-1";
export var link = "_ou-b";
export var merchant = "_ou-5";
export var message = "_ou-c";
export var profilePicture = "_ou-e";
export var quillToolbarContainer = "_ou-f";
export var senderDate = "_ou-g";
export var senderDateCustomer = "_ou-h";
export var senderName = "_ou-d";
export var time = "_ou-k";
export var uploadedImage = "_ou-l";
export var username = "_ou-m";
export var xsmall = "_ou-n";